import React from "react";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import { Input, Button } from "semantic-ui-react";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
    // marginBottom: theme.spacing(1),
  },
  textField: {
    // marginLeft: theme.spacing(1),
    // marginRight: theme.spacing(1),
    width: "100%",
    marginBottom: theme.spacing(1),
  },
}));

const CreateForm = ({ handleChange, handleSubmit, values, isDisabled }) => {
  const classes = useStyles();

  return (
    <form onSubmit={handleSubmit} className="mainForm">
      <Input
        type="text"
        name="title"
        label="Title"
        className="regInput"
        value={values.title}
        onChange={handleChange}
        autoFocus
        placeholder="Event title"
      />
      <Input
        type="text"
        name="desc"
        label="Description"
        // className="regInput"
        value={values.desc}
        onChange={handleChange}
        placeholder="(up to 177 characters)"
        rows={2}
      />
      <br />
      <TextField
        id="date"
        name="date"
        onChange={handleChange}
        label="Event date"
        type="date"
        value={values.date}
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
      />
      <TextField
        id="time"
        name="time"
        value={values.time}
        onChange={handleChange}
        label="Time of day"
        type="time"
        className={classes.textField}
        InputLabelProps={{
          shrink: true,
        }}
        // inputProps={{
        //   step: 1500, // 5 min
        // }}
      />
      <Button disabled={isDisabled} type="submit" basic color="purple">
        Create Event
      </Button>
    </form>
  );
};

export default CreateForm;
